import React from "react"
export default function TargetForecastSubRegional() {
  return <h1>TARGET FORECAST INPUT SUB REGIONAL</h1>
}
